<template>
    <!--            &#45;&#45; Tailwind UI -> Data Display -> Description Lists -> Left-aligned in card &#45;&#45;-->
    <div class="w-full bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6 mb-2 sm:mb-10">
            <p class="mt-1 max-w-2xl text-lg leading-5 text-gray-800">
                Alarms can be snoozed to disable notifications to users for a specified period of time.
            </p>
            <p class="mt-1 max-w-2xl text-lg leading-5 text-gray-800">
                By snoozing this alarm, no new alarms will be created and no notifications will occur until
                either the alarm is resolved or the snooze expires.
            </p>
        </div>
        <div class="px-4 pt-5 pb-0 sm:pb-5 sm:p-0">
            <dl>
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                    <dt class="text-md leading-5 font-medium text-gray-700">
                        How long to snooze this alarm?
                        <p class="text-sm pt-4 text-grey-500"><i>Silence Alarm</i> will snooze the alarm
                            indefinitely.
                        </p>
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                        <!--                                &#45;&#45; Tailwind UI -> Elements -> Button Groups -> Basic&#45;&#45;-->
                        <span class="relative z-0 flex shadow-sm mb-2">
                              <button type="button" @click="snoozeTimeClick"
                                      value="1"
                                      :class="{'bg-blue-100': snoozeTime === '1', 'bg-white' : snoozeTime !== '1'}"
                                      class="w-1/3 items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                1hr
                              </button>
                              <button type="button" @click="snoozeTimeClick"
                                      value="6"
                                      :class="{'bg-blue-100': snoozeTime === '6', 'bg-white' : snoozeTime !== '6'}"
                                      class="-ml-px w-1/3 items-center px-4 py-2 border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                6hr
                              </button>
                              <button type="button" @click="snoozeTimeClick"
                                      value="24"
                                      :class="{'bg-blue-100': snoozeTime === '24', 'bg-white' : snoozeTime !== '24'}"
                                      class="-ml-px w-1/3 items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                24hr
                              </button>
                            </span>
                        <span class="relative z-0 flex shadow-sm mb-2">
                              <button type="button" @click="snoozeTimeClick"
                                      value="tomorrow"
                                      :class="{'bg-blue-100': snoozeTime === 'tomorrow', 'bg-white' : snoozeTime !== 'tomorrow'}"
                                      class="w-1/2 items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Tomorrow Morning
                              </button>
                              <button type="button" @click="snoozeTimeClick"
                                      value="monday"
                                      :class="{'bg-blue-100': snoozeTime === 'monday', 'bg-white' : snoozeTime !== 'monday'}"
                                      class="-ml-px w-1/2 items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Next Monday
                              </button>
                            </span>
                        <span class="relative z-0 flex shadow-sm mb-2">
                              <button type="button"
                                      @click="snoozeTimeClick"
                                      value="custom"
                                      :class="{'bg-blue-100': snoozeTime === 'custom', 'bg-white' : snoozeTime !== 'custom'}"
                                      class="w-1/2 items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Custom Duration
                              </button>
                              <button type="button" @click="snoozeTimeClick"
                                      value="silence"
                                      :class="{'bg-blue-100': snoozeTime === 'silence', 'bg-white' : snoozeTime !== 'silence'}"
                                      class="-ml-px w-1/2 items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 text-lg font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                Silence Alarm
                              </button>
                        </span>
                        <span class="relative z-0 flex shadow-sm mb-2" v-show="showDatetime">
                            <date-time-picker   class="grow"
                                                v-model="datetime"
                                                :min-date="minDate"
                                                :side-by-side="true"
                                                vertical-position="top"
                                                :timezone="timezone"
                                                format="MM/DD/YYYY HH:mm"></date-time-picker>
                        </span>
                    </dd>
                </div>

                <!-- Comments for snooze. -->
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                        <textarea v-model="comments" class="w-full border-2 p-4" rows="4" placeholder="Enter any comments here"></textarea>
                    </dd>
                </div>
            </dl>
        </div>

        <!-- Button to snooze alarms. -->
        <div class="px-4 pb-5 pt-2 sm:pt-5 sm:border-t mt-2 p-1">
            <div    v-if="errorsSnoozing !== {}"
                    class="pb-4">
                <!-- Error Banner -->
                <banner-error   v-for="(error, errorTitle) in errorsSnoozing">
                    <template   #title>
                        {{ errorTitle }}
                    </template>

                    <template   #content>
                        {{ error }}
                    </template>
                </banner-error>

            </div>
            <div>
                <dl class="mb-0">
                    <span class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="!anythingSelected"
                                :class="{'bg-gray-400': !anythingSelected, 'bg-blue-600 hover:bg-blue-500': anythingSelected}"
                                class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 active:bg-blue-700 sm:w-auto sm:text-sm sm:leading-5">
                          Snooze Alarm
                        </button>
                    </span>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    import DateTimePicker from "@/components/Reports/DateTimePicker";
    import { DateTime as LuxonDatetime}  from 'luxon';
    import axios from 'axios';
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import BannerError from "@/components/Banners/BannerError.vue";
    export default {
        name: "alarmAddressSnooze",
        mixins: [SonicuCoreMixin],
        components: {DateTimePicker, BannerError},
        props: {
            timezone: {
                type: String,
                default: 'utc',
            },
            sendEventOnly: Boolean,
        },
        data() {
            return {
                showDatetime: false,
                luxDateTime: LuxonDatetime.utc().plus({days: 7, hours: 1}),
                datetime: null,
                comments: null,
                snoozeTime: null,
                errorsSnoozing: {},
            }
        },
        mounted() {
            this.luxDateTime = this.luxDateTime.setZone(this.timezone)
            this.datetime = this.luxDateTime.toJSDate()
        },
        computed: {
            anythingSelected() {
                return this.snoozeTime !== null;
            },
            minDate(){
                let time = LuxonDatetime.utc()
                return time.setZone(this.timezone).toJSDate()
            }
        },
        methods: {
            snoozeTimeClick(event){
                if(event.target.value.localeCompare("custom") === 0){
                    this.showDatetime = true;
                } else {
                    // You must use 'this' or it won't update
                    this.showDatetime = false;
                }
                this.snoozeTime = event.target.value;
            },
            sendFormData(){
                this.errorsSnoozing = {}
                // Get the datetime independent of timezone (despite timezone being tied to the var) and we will format it to iso for the request.
                let zoneLessDatetime = LuxonDatetime.fromJSDate(this.datetime)
                    .setZone('utc', {keepLocalTime: true})

                let data = {
                    'addressed': 'snooze',
                    'snooze_time': this.snoozeTime,
                    // This ISO String should be formatted as UTC, but be local time.
                    'datetime': zoneLessDatetime,
                    'comments': this.comments,
                }

                if (this.sendEventOnly) {
                    // If we're only sending the event, emit the event and return
                    this.$emit('snoozing-alarm', data)
                    return
                }

                axios.patch(window.location.pathname, data
                ).then(response => {
                    let data = response.data
                    if (_.size(data.errors) > 0) {
                        // If errors occured, display errors, then after 5 seconds, reload the page
                        this.errorsSnoozing = data.errors;
                        setTimeout(() => {
                            window.location.reload()
                        }, 10000);
                        return
                    }

                    // No errors occured
                    window.location.href = this.company.buildCompanyRoute('alarms');
                    return false;
                })
            }
        }
    }
</script>

<style scoped>
.vdatetime-input {
    @apply text-center;
}
</style>